import React from 'react';
import { RaceCalendarContextData } from './types';

export const RaceCalendarContext = React.createContext<RaceCalendarContextData>(
  {} as RaceCalendarContextData,
);

export default RaceCalendarContext;
